import { Component } from '@angular/core';
import { App } from 'ionic-angular';
import { LoginPage } from '../login/login';
import { AboutPage } from '../about/about';
import { AccountPage } from '../account/account';
import { CategoryPage } from '../category/category';
import { PostFeedbackPage } from '../post-feedback/post-feedback';
import { TermsOfServicePage } from '../terms-of-service/terms-of-service';
import {PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
//import { HomePage } from '../home/home';

import { User } from '../../providers/providers';

const url = 'https://cdn.chitika.net/getads.js';

@Component({
  templateUrl: 'settings.html'
})
export class SettingsPage {

  loadAPI: Promise<any>;
  public aboutPage = AboutPage;
  public accountPage = AccountPage;
  public categoryPage = CategoryPage;
  public postFeedbackPage = PostFeedbackPage;
  public termsOfServicePage = TermsOfServicePage;
  public privacyPolicyPage = PrivacyPolicyPage;
  //public homePage = HomePage;
  public placement_id:number;
  public bannerId:string = "not set";

  constructor(public user: User, public app: App) {
    //this.chitikaAddHeight();

  }

  logout() {
    this.user.logout();
    this.app.getRootNav().setRoot(LoginPage);
  }

  chitikaAddHeight(){
    if (window['CHITIKA'] === undefined) { window['CHITIKA'] = { 'units' : [] }; };
          var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
          this.placement_id = window['CHITIKA'].units.length;
          window['CHITIKA'].units.push(unit);
          this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
          //document.write('<div id="chitikaAdBlock-' + this.placement_id + '"></div>');
  }

  ngAfterViewInit(){
    this.loadAPI = new Promise((resolve) => {
        console.log('resolving promise...');
        this.loadScript();
    }).catch((err)=>{
      let t = err;
      console.log(t);
    });
}



public loadScript() {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.chitikaAddHeight();
}
  
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts